module.exports = __webpack_public_path__ + "static/media/ladies_accessories_3.26770e36.jpg";